/**
 * Copyright © 2025-2026 Delicious AI, LLC
 */

import { css, Global } from '@emotion/react'
import React from 'react'

const GlobalStyle = (props: any) => (
  <Global
    {...props}
    styles={css`
      html,
      body,
      #root {
        height: 100%;
      }

      body {
        margin: 0;
      }

      .MuiCardHeader-action .MuiIconButton-root {
        padding: 4px;
        width: 28px;
        height: 28px;
      }

      /* IMPORTANT: Need this for 'react-google-autocomplete' dropdown to show in a MUI Dialog */
      .pac-container {
        z-index: 1500 !important;
        position: fixed !important;
      }
    `}
  />
)

export default GlobalStyle
